import * as Yup from 'yup';
import * as message from '../../../constant/message';

export const validationMaterialSchema = Yup.object().shape({
  name: Yup.string().required(message.MATERIAL_NAME_REQUIRED),
  rate: Yup.number().required(message.MATERIAL_RATE_REQUIRED),
  // startLandmarkDescription: Yup.string().required(message.START_LANDMARK_REQUIRED),
  // endLandmarkDescription: Yup.string().required(message.END_LANDMARK_REQUIRED),
});
